class BreadcrumbScroll {
  constructor(root) {
    this.root = root instanceof Element ? root : document.querySelector(root);

    if (!this.root) {
      return;
    }

    this.track = this.root.querySelector('.c-page-header__breadcrumb-track');

    if (!this.track) {
      return;
    }

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.scrollToStart();
    this.update();
  }

  scrollToStart() {
    this.track.scrollLeft = 0;
  }

  onScroll() {
    this.update();
  }

  onResize() {
    this.scrollToStart();
    this.update();
  }

  update() {
    const { scrollWidth, clientWidth, scrollLeft } = this.track;
    const hasOverflow = scrollWidth > clientWidth + 1;

    this.root.classList.toggle('is-overflow', hasOverflow);
    this.root.classList.toggle('is-left-hidden', hasOverflow && scrollLeft > 1);
  }
}
